import { connect } from 'react-redux'
import mobileEditorSelector from './mobileEditorSelector'
import {
  add as addUnsavedChange,
  remove as removeUnsavedChange
} from 'store/redux/unsavedChanges'
import MobileEditor from './MobileEditor'

export default connect(
  mobileEditorSelector,
  {
    addUnsavedChange,
    removeUnsavedChange
  },
  null,
  {
    forwardRef: true
  }
)(MobileEditor)
